<template>
    <div id="additionals-auto-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Доборные элементы</div>
        <div class="sidebar-text-area">
            Чтобы добавить наличник для окна или двери, <span class="red-text bold-text">выберите</span> кликом мыши плоскость <span class="red-text bold-text">оконного</span> или <span class="red-text bold-text">дверного проёма</span> в рабочей области.
        </div>
        <div class="sidebar-step-two-img-container additional-img-container">
            <img class="sidebar-additional-img" :src="urlForStatic('/img/additionals_auto_tip_1.png')"/>
        </div>
        <div class="sidebar-text-area">
            Затем нажмите на кнопку <span class="red-text bold-text">"добавить наличник"</span> на нижней панели. Плоскости доборных элементов будут автоматически созданы вокруг выбранного объекта.
        </div>
        <div class="sidebar-step-two-img-container additional-img-container">
            <img class="sidebar-additional-img" :src="urlForStatic('/img/additionals_auto_tip_2.png')"/>
        </div>
        <div class="sidebar-text-area">
            Если Вам необходимо добавить произвольный доборный элемент, воспользуйтесь <span class="red-text bold-text">свободным добавлением</span>.
        </div>
        <div class="red-rectangle-button-of-love btn-additional-manual" v-on:click="goManualAdditions">
            Свободное добавление
        </div>
    </div>
</template>

<script>
    import store from "../../../store";
    import {urlForStaticVue} from "../../common";

    export default {
        name: "AdditionalsAutoSidebarMenu",
        mixins: [urlForStaticVue],
        methods: {
            async goManualAdditions() {
                const planeID = await store.dispatch(`active/ADD_PLANE`,
                    {
                        type: "additional",
                    })
                await this.$router.push({
                    name: "additionalManual",
                    params: {
                        planeID: planeID
                    },
                    query: this.$route.query
                }).catch(() => {});
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-height: 800px) {
        .sidebar-additional-img {
            max-height: 90px;
        }
    }

    @media screen and (min-height: 800px) {
        .sidebar-additional-img {
            max-height: 450px;
        }
    }

    .additional-img-container {
        text-align: center;
    }

    .sidebar-additional-img {
        max-width: 100%;
        height: auto;
        box-sizing: border-box;
    }

    .btn-additional-manual {
        padding: 10px 0 !important;
        height: auto !important;
    }
</style>
